import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import "../../ThemeProvider/ThemeProvider.mjs";
import "../../ThemePortal/ThemePortal.mjs";
import "../../Text/TextContext.mjs";
import "../../ThemeProvider/ThemeContext.mjs";
import "../../ThemeProvider/VanillaThemeContainer.mjs";
import "../DefaultMessagesContext.mjs";
import "../../ThemeProvider/BreakpointContext.mjs";
import "../../../css/atoms/sprinkles.css.mjs";
import { PublicBox } from "../../Box/Box.mjs";
import "../../Box/BackgroundContext.mjs";
import "../../Divider/Divider.css.mjs";
import "../../Heading/HeadingContext.mjs";
import "../../Hidden/Hidden.css.mjs";
import "../../../css/negativeMargin/negativeMargin.css.mjs";
import "../../Accordion/AccordionContext.mjs";
import { Text } from "../../Text/Text.mjs";
import "../../Columns/ColumnsContext.mjs";
import "../../Column/Column.css.mjs";
import "../../../css/lineHeightContainer.css.mjs";
import "../../../css/reset/reset.css.mjs";
import "../../../hooks/useIcon/icon.css.mjs";
import "../../../css/typography.css.mjs";
import { IconClose } from "../../icons/IconClose/IconClose.mjs";
import "../touchable/virtualTouchable.css.mjs";
import "../hideFocusRings/hideFocusRings.css.mjs";
import "../../Accordion/AccordionItem.css.mjs";
import "../../Actions/ActionsContext.mjs";
import "../../../css/textAlignedToIcon.css.mjs";
import "../../Alert/Alert.css.mjs";
import "../../Autosuggest/Autosuggest.mjs";
import "../../Avatar/Avatar.css.mjs";
import "../../Badge/Badge.mjs";
import "../../Breadcrumb/Breadcrumb.css.mjs";
import "../../Box/ColoredBox.mjs";
import { Button } from "../../Button/Button.mjs";
import "../../ButtonIcon/ButtonIcon.mjs";
import "../../ButtonLink/ButtonLink.mjs";
import "../Keyline/Keyline.css.mjs";
import "../../Checkbox/Checkbox.mjs";
import "../../Checkbox/CheckboxStandalone.mjs";
import "../../ContentBlock/ContentBlock.css.mjs";
import "../../DateField/DateField.mjs";
import "../Field/FloatingLabel.css.mjs";
import "../Field/Field.css.mjs";
import "../../DateField/DateField.css.mjs";
import "../Modal/Modal.mjs";
import "../Modal/ModalContent.mjs";
import "../Modal/ModalContext.mjs";
import "../../TextLink/TextLink.mjs";
import "../../TextLinkButton/TextLinkButton.css.mjs";
import "../AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../../Dropdown/Dropdown.mjs";
import "../MaxLines/MaxLines.css.mjs";
import "../../HiddenVisually/HiddenVisually.css.mjs";
import "../../Link/Link.mjs";
import "../defaultTextProps.mjs";
import "../../List/List.css.mjs";
import "../../Loader/Loader.css.mjs";
import "../../Skeleton/Skeleton.css.mjs";
import "../../MenuRenderer/MenuRenderer.mjs";
import { MenuItem } from "../../MenuItem/MenuItem.mjs";
import "../../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../../MenuItemDivider/MenuItemDivider.mjs";
import "../../MenuItem/MenuItemLink.mjs";
import { OverflowMenu } from "../../OverflowMenu/OverflowMenu.mjs";
import "../../MonthPicker/MonthPicker.mjs";
import "../../Pagination/Pagination.css.mjs";
import "../../PasswordField/PasswordField.mjs";
import "../../Pincode/Pincode.mjs";
import "../../PopoverRenderer/PopoverRenderer.mjs";
import "../../Pressable/Pressable.mjs";
import "../../RadioGroup/RadioGroup.mjs";
import "../../RadioGroup/RadioItem.mjs";
import "../../RadioGroup/RadioItemBlock.mjs";
import { ResponsiveRender } from "../../ResponsiveRender/ResponsiveRender.mjs";
import "../../SelectableList/SelectableList.css.mjs";
import { bulkActionsContainer, showToolbar, hideToolBar, toolbarWrapper, bulkActionButtonWrapper, bulkActionDivider } from "./BulkActions.css.mjs";
import "../../Spread/Spread.css.mjs";
import "../../Stepper/Step.mjs";
import "../../Stepper/Stepper.mjs";
import "../../Tabs/Tab.mjs";
import "../../Table/Table.mjs";
import "../../Table/Table.css.mjs";
import "../../Tabs/TabsProvider.mjs";
import "../../Tabs/TabListContext.mjs";
import "../../Tabs/Tabs.css.mjs";
import "../../Tabs/TabPanelsContext.mjs";
import "../../Tag/Tag.css.mjs";
import "../../Textarea/Textarea.mjs";
import "../../TextDropdown/TextDropdown.css.mjs";
import "../../TextField/TextField.mjs";
import "../../Tiles/Tiles.css.mjs";
import "../../Toggle/Toggle.mjs";
import "../../useToast/ToastContext.mjs";
import "../../TooltipRenderer/TooltipRenderer.mjs";
import "../../TimeField/DateSegment.css.mjs";
import "../FieldButtonIcon/FieldButtonIcon.mjs";
import "../../MultiStepModal/MultiStepModal.mjs";
import "../../SearchField/SearchField.mjs";
import "../../RadioBar/RadioBarContext.mjs";
import "../../RadioBar/RadioBar.css.mjs";
import "../../../themes/vars.css.mjs";
import "../../RadioBar/RadioBar.mjs";
function BulkActions({
  visible,
  selectedItemsLength,
  selectedItems,
  totalItems,
  itemsSelectedText,
  bulkActions,
  clearAllText,
  clearAllSelectedRows
}) {
  return /* @__PURE__ */ jsx(PublicBox, { className: [bulkActionsContainer, visible ? showToolbar : hideToolBar], children: /* @__PURE__ */ jsxs(PublicBox, { className: toolbarWrapper, role: "toolbar", "aria-hidden": !visible, children: [
    /* @__PURE__ */ jsx(Text, { tone: "formAccent", children: `${selectedItemsLength}/${totalItems} ${itemsSelectedText}` }),
    /* @__PURE__ */ jsxs(PublicBox, { display: "flex", justifyContent: "flexStart", alignItems: "center", children: [
      /* @__PURE__ */ jsx(PublicBox, { className: bulkActionButtonWrapper, children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: clearAllSelectedRows,
          icon: /* @__PURE__ */ jsx(IconClose, {}),
          variant: "transparent",
          size: "small",
          children: clearAllText
        }
      ) }),
      Boolean(bulkActions) && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(ResponsiveRender, { above: "mobile", children: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(PublicBox, { className: bulkActionDivider, children: " " }),
          bulkActions == null ? void 0 : bulkActions.map((action, index) => /* @__PURE__ */ jsx(PublicBox, { className: bulkActionButtonWrapper, children: /* @__PURE__ */ jsx(
            Button,
            {
              onClick: () => action.onClick(selectedItems),
              icon: action.icon,
              variant: "transparent",
              size: "small",
              children: action.label
            }
          ) }, index))
        ] }) }),
        /* @__PURE__ */ jsx(ResponsiveRender, { below: "tablet", children: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(PublicBox, { className: bulkActionDivider, children: " " }),
          /* @__PURE__ */ jsx(OverflowMenu, { label: "Options", id: "options", children: bulkActions == null ? void 0 : bulkActions.map((action, index) => /* @__PURE__ */ jsx(MenuItem, { onClick: () => action.onClick(selectedItems), children: action.label }, index)) })
        ] }) })
      ] })
    ] })
  ] }) });
}
export {
  BulkActions
};
